import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import RoomTypePriceBuilderButtons from "./RoomTypePriceBuilderButtons";
import RoomTypePriceBuilderWorkspace from "./RoomTypePriceBuilderWorkspace";
import Tabs from "../Tabs/Tabs";
import RoomTypePriceBuilderErrors from "./RoomTypePriceBuilderErrors";
import ObjectHelper from "../ObjectHelper/ObjectHelper";
import { parseISO } from "date-fns";

class RoomTypePriceBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getStateFromProps(this.props);
    this.onChange = this.onChange.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeRoomType = this.onChangeRoomType.bind(this);
    this.onChangeSeasonalPrices = this.onChangeSeasonalPrices.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeAllDays = this.onChangeAllDays.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeAllMinimumStays = this.onChangeAllMinimumStays.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var state = this.getStateFromProps(nextProps);

    this.setState(state);
  }

  componentDidMount() {
    var self = this;
    $(window).on("basePriceSaved", function () {
      $.ajax({
        type: "POST",
        url: `/admin/base-prices/${self.props.id}/data`,
      }).done((data) => {
        self.setState({
          ...data,
          read_only: true,
          loading: false,
        });
      });
    });
  }

  render() {

    return (
      <div className="room-type-price-builder">
        {this.state.tabs ? (
          <Tabs
            tabs={this.tabs()}
            displayErrorMessage={
              RoomTypePriceBuilderErrors.general(this.state.errors).length ||
              RoomTypePriceBuilderErrors.seasonal_pricing(this.state.errors)
                .length
                ? true
                : false
            }
          />
        ) : null}
        <RoomTypePriceBuilderButtons
          historical_view={this.props.historical_view}
          nested={this.state.nested}
          onSave={this.onSave}
          read_only={this.props.read_only}
        />
        <div className="panel panel-form">
          <RoomTypePriceBuilderWorkspace
            {...this.props}
            {...this.state}
            room_type_price={{
              sunday_amount: this.state.sunday_amount,
              monday_amount: this.state.monday_amount,
              tuesday_amount: this.state.tuesday_amount,
              wednesday_amount: this.state.wednesday_amount,
              thursday_amount: this.state.thursday_amount,
              friday_amount: this.state.friday_amount,
              saturday_amount: this.state.saturday_amount,

              sunday_minimum_stay: this.state.sunday_minimum_stay,
              monday_minimum_stay: this.state.monday_minimum_stay,
              tuesday_minimum_stay: this.state.tuesday_minimum_stay,
              wednesday_minimum_stay: this.state.wednesday_minimum_stay,
              thursday_minimum_stay: this.state.thursday_minimum_stay,
              friday_minimum_stay: this.state.friday_minimum_stay,
              saturday_minimum_stay: this.state.saturday_minimum_stay,
              start_date: this.state.start_date,
              additional_guest_amount: this.state.additional_guest_amount,
              max_guests_allowed: this.state.max_guests_allowed,
              guests_included: this.state.guests_included,
              room_type_id: this.state.room_type ? this.state.room_type.id : "",
              updated_at: this.state.updated_at,
            }}
            onChange={this.onChange}
            onChangeStartDate={this.onChangeStartDate}
            onChangeRoomType={this.onChangeRoomType}
            onChangeSeasonalPrices={this.onChangeSeasonalPrices}
            onChangeAllDays={this.onChangeAllDays}
            onChangeAllMinimumStays={this.onChangeAllMinimumStays}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  renderErrors() {
    var errs = this.processErrors(this.state.errors);

    if (errs && errs.length) {
      var idx = 0;
      var errors = errs.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  onChange(event) {
    if (event && event.target) {
      if (this.props.nested) {
        var name = event.target.name;
        name = name.substr("room_type_price_attributes[".length);
        name = name.substr(0, name.length - 1);
        this.state[name] = event.target.value;
      } else {
        this.state[event.target.name] = event.target.value;
      }

      this.forceUpdate(() => {
        if (typeof this.props.onChange == "function") {
          this.props.onChange(this.state);
        }
      });
    } else {
    }
  }

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeRoomType(room_type) {
    this.setState({ room_type: room_type });
  }

  onChangeSeasonalPrices(seasonal_prices) {
    this.setState({ seasonal_prices: seasonal_prices });
  }

  onChangeAllDays(e) {
    var newPrices = this.state;
    newPrices.sunday_amount = e;
    newPrices.monday_amount = e;
    newPrices.tuesday_amount = e;
    newPrices.wednesday_amount = e;
    newPrices.thursday_amount = e;
    newPrices.friday_amount = e;
    newPrices.saturday_amount = e;
    this.setState({ ...newPrices });

    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onChangeAllMinimumStays(e) {
    var newMinimum = this.state;
    newMinimum.sunday_minimum_stay = e;
    newMinimum.monday_minimum_stay = e;
    newMinimum.tuesday_minimum_stay = e;
    newMinimum.wednesday_minimum_stay = e;
    newMinimum.thursday_minimum_stay = e;
    newMinimum.friday_minimum_stay = e;
    newMinimum.saturday_minimum_stay = e;
    this.setState({ ...newMinimum });

    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onChangeStartDate(date) {
    this.state.start_date = date;
    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onSave() {
    if (!this.props.read_only) {
      this.setState({ loading: true });

      var seasonal_prices = [];
      for (var i = 0, ilen = this.state.seasonal_prices.length; i < ilen; i++) {
        var seasonal_price = ObjectHelper.clone(this.state.seasonal_prices[i]);
        delete seasonal_price["season"];
        seasonal_prices.push(seasonal_price);
      }

      $.ajax({
        type: this.props.new_record ? "POST" : "PUT",
        url: this.props.form_action,
        data: {
          room_type_price: {
            sunday_amount: this.state.sunday_amount,
            monday_amount: this.state.monday_amount,
            tuesday_amount: this.state.tuesday_amount,
            wednesday_amount: this.state.wednesday_amount,
            thursday_amount: this.state.thursday_amount,
            friday_amount: this.state.friday_amount,
            saturday_amount: this.state.saturday_amount,

            sunday_minimum_stay: this.state.sunday_minimum_stay,
            monday_minimum_stay: this.state.monday_minimum_stay,
            tuesday_minimum_stay: this.state.tuesday_minimum_stay,
            wednesday_minimum_stay: this.state.wednesday_minimum_stay,
            thursday_minimum_stay: this.state.thursday_minimum_stay,
            friday_minimum_stay: this.state.friday_minimum_stay,
            saturday_minimum_stay: this.state.saturday_minimum_stay,
            start_date: this.state.start_date,
            additional_guest_amount: this.state.additional_guest_amount,
            max_guests_allowed: this.state.max_guests_allowed,
            guests_included: this.state.guests_included,
            room_type_id: this.state.room_type ? this.state.room_type.id : "",
            updated_at: this.state.updated_at,
          },
          seasonal_prices: seasonal_prices,
        },
      })
        .done((data) => {
          this.setState({ loading: false });
          if (parent && parent.refresh_data) {
            if (this.props.new_record == true) {
              parent.refresh_data(
                I18n.t("room_type_price_created_successfully")
              );
            } else {
              parent.refresh_data(I18n.t("room_type_price_saved_successfully"));
            }
          }

          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        })
        .catch((data) => {
          if (data && data.responseJSON) {
            this.setState({ errors: data.responseJSON, loading: false });
            $(".modal-body").scrollTop(0);
          }
        });
    }
  }

  /*******************
   * Helper functions *
   ********************/

  getStateFromProps(props) {
    var start_date = props.start_date;
    if (!props.roomTypePrice && props.start_date) {
      start_date = parseISO(props.start_date);
    }

    return {
      active_tab: "general",
      loading: false,
      id: props.id || "-0",
      errors: props.errors || [],

      sunday_amount: props.sunday_amount || "",
      monday_amount: props.monday_amount || "",
      tuesday_amount: props.tuesday_amount || "",
      wednesday_amount: props.wednesday_amount || "",
      thursday_amount: props.thursday_amount || "",
      friday_amount: props.friday_amount || "",
      saturday_amount: props.saturday_amount || "",

      sunday_minimum_stay: props.sunday_minimum_stay || "",
      monday_minimum_stay: props.monday_minimum_stay || "",
      tuesday_minimum_stay: props.tuesday_minimum_stay || "",
      wednesday_minimum_stay: props.wednesday_minimum_stay || "",
      thursday_minimum_stay: props.thursday_minimum_stay || "",
      friday_minimum_stay: props.friday_minimum_stay || "",
      saturday_minimum_stay: props.saturday_minimum_stay || "",
      start_date: start_date,

      seasonal_prices: props.seasonal_prices || [],
      max_guests_allowed: props.max_guests_allowed || "",
      nested: typeof props.nested != "undefined" ? props.nested : false,
      guests_included: props.guests_included || "",
      additional_guest_amount: props.additional_guest_amount || "",
      room_type: props.room_type,
      daily_rental: props.daily_rental || false,
      updated_at: props.updated_at,
      tabs: typeof props.tabs != "undefined" ? props.tabs : true,
    };
  }

  processErrors(errors) {
    var err = [];

    for (var i in errors) {
      if (errors[i] && errors[i] != "") {
        if (i == "base") {
          err.push(errors[i]);
        } else {
          err.push(I18n.t(i) + " " + errors[i]);
        }
      }
    }
    return err;
  }

  tabs() {
    if (this.props.historical_view == true) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RoomTypePriceBuilderErrors.general(this.state.errors)
            .length,
        },
      ];
    } else if (this.props.read_only) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RoomTypePriceBuilderErrors.general(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("history"),
          targetName: "history",
          classes: this.state.active_tab === "history" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RoomTypePriceBuilderErrors.general(this.state.errors)
            .length,
        },
      ];
    }
  }
}

export default RoomTypePriceBuilder;
